import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import DatePicker, { DateObject } from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';

// --- Import Icons ---
import {
    MdAddLocation,
    MdCalendarMonth,
    MdOutlineDescription,
    MdOutlineRadioButtonChecked,
    MdOutlineRadioButtonUnchecked,
    MdAdd,
    MdAttachFile,
    MdClose, MdLocalShipping, MdStorefront, MdInfo, MdWrongLocation,

} from 'react-icons/md';
import { TbArrowBadgeLeft } from 'react-icons/tb';

// --- Import API & Helpers ---
import { getAddresses, storeRequest } from '../api/RequestsAPI';
import { showError } from '../../../utils/toastHelper';
import Header from '../../../layouts/Header';
import Loading from '../../../layouts/Loading';


import 'react-multi-date-picker/styles/layouts/mobile.css';
import {PiCoinsBold} from "react-icons/pi";
const currencyFormat = Intl.NumberFormat('en-US');

function SetRequestOptions() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [isUrgent, setIsUrgent] = useState(false);
    const [addresses, setAddresses] = useState([]);

    const [description, setDescription] = useState('');
    const [date, setDate] = useState(new DateObject({ calendar: persian }).add(1, 'days'));
    const [selectedHour, setSelectedHour] = useState("");
    const [attachment, setAttachment] = useState(null);
    const fileInputRef = useRef(null);

    const config = window.APP_CONFIG;
    // استیت برای نگهداری نوع مراجعه: 'delivery' یا 'pickup'
    const [visitType, setVisitType] = useState('delivery'); // پیش‌فرض: ارسال به آدرس

    // استیت برای نگهداری آدرس انتخاب شده
    const [selectedAddressId, setSelectedAddressId] = useState(0);


    const handleFileChange = (e) => {

        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const maxFileSize = config.service_app_settings.file_size * 1024 * 1024; // ۲ مگابایت به بایت

            if (file.size > maxFileSize) {
                toast.warn("حداکثر حجم فایل مجاز ۲ مگابایت می‌باشد.");
                e.target.value = null;
                setAttachment(null);
                return;
            }

            setAttachment(file);
        }
    };



    useEffect(() => {
        const fetchAddresses = async () => {
            try {
                const request = { list: 1, vendor: 1 };
                const result = await getAddresses(request);
                setAddresses(result.data);

                if (result.data.length === 1) {
                    if(result.data[0].address.distance_fee > 0){
                        setSelectedAddressId(result.data[0].id);
                    }

                }


                if (config.service_app_settings.normal_delivery === "0" && config.service_app_settings.no_delivery === "1") {
                    setSelectedAddressId(-1);
                    setVisitType('pickup')
                }

            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        };

        fetchAddresses();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const onStoreRequest = async () => {
        if (selectedAddressId === 0) {
            toast.warn("لطفاً یک آدرس انتخاب کنید.");
            return;
        }
       if (!isUrgent && !selectedHour) {
            toast.warn("لطفاً بازه زمانی مراجعه را انتخاب کنید.");
            return;
        }


        setLoading(true);

        const services = JSON.parse(window.localStorage.getItem("cart"));

        // --- ایجاد FormData ---
        const formData = new FormData();

        // --- افزودن تمام داده‌ها به formData ---
        formData.append('company_id', 1);
        formData.append('is_urgent', isUrgent);
        formData.append('address_id', selectedAddressId);

        formData.append('doing_date', isUrgent ? null : date?.toDate?.().getFullYear() + '-' + (date?.toDate?.().getMonth() - -1) + '-' +date?.toDate?.().getDate());
        formData.append('doing_time', isUrgent ? '' : selectedHour);
        formData.append('user_description', description);


        formData.append('services', JSON.stringify(services));

        // --- افزودن فایل در صورت وجود ---
        if (attachment) {
            formData.append('attachment', attachment);
        }

        try {
            // ارسال formData به API
            const result = await storeRequest(formData);
            toast.success(result.message);
            window.localStorage.removeItem("cart");
            setTimeout(() => {
                window.location.replace(`/requests/${result.data.id}`);
            }, 1500);
        } catch (err) {
            showError(err);
            setLoading(false);
        }
    };

    if (loading) {
        return <Loading />;
    }

    return (
        <div className="set-request-options-page pt-5 mt-3 container">
            <Header title="تنظیم مشخصات درخواست" hasBack={true} />

            <div className="page-content">
                <div className="row">
                    <div className="col-12">
                        <div className="alert alert-warning text-justify text-small-1">
                            <p dangerouslySetInnerHTML={{__html: config.service_app_settings.option_page_text}}></p>

                        </div>
                    </div>
                </div>
                {/* --- Address Section --- */}
                <div className="options-section">
                    <h2 className="section-title">
                        <MdAddLocation/>
                        <span>انتخاب آدرس و نحوه مراجعه</span>
                    </h2>

                    {/* بخش انتخاب نوع مراجعه */}
                    <div className="visit-type-selector">
                        {
                            config.service_app_settings.normal_delivery === "1" && config.service_app_settings.no_delivery === "1" &&

                            <div
                                className={`visit-option ${visitType === 'delivery' ? 'selected' : ''}`}
                                onClick={() => {
                                    if (addresses.length === 1) {
                                        setSelectedAddressId(addresses[0].id);
                                    }
                                    setVisitType('delivery')
                                }}
                            >
                                <MdLocalShipping className="visit-icon"/>
                                <span>
                                مراجعه به آدرس شما
                            </span>
                            </div>
                        }

                        {
                            config.service_app_settings.normal_delivery === "1" && config.service_app_settings.no_delivery === "1" &&
                        <div
                            className={`visit-option ${visitType === 'pickup' ? 'selected' : ''}`}
                            onClick={() => {
                                setVisitType('pickup')
                                setSelectedAddressId(-1)
                            }}
                        >
                            <MdStorefront className="visit-icon"/>
                            <span>مراجعه حضوری</span>
                        </div>
                        }
                    </div>

                    {/* نمایش محتوای شرطی بر اساس نوع مراجعه */}
                    <div className="content-area">
                        {visitType === 'delivery' ? (
                            <>
                            <div className="address-list">
                                <div className='mb-3 text-small-2 fw-bold text-muted'>
                                    <MdInfo className='mx-2' />
                                    لطفا آدرس خود را انتخاب کنید و یا آدرس جدیدی ثبت کنید:
                                </div>
                                    {addresses.map(address => (
                                        <div
                                            key={address.id}
                                            className={`address-card ${address.id === selectedAddressId ? 'selected' : ''}`}
                                            onClick={() => {
                                                if (address.distance_fee > 0) {
                                                    setSelectedAddressId(address.id);
                                                }
                                                else {
                                                    showError('آدرس خارج از محدوده سرویس دهی است!')
                                                }


                                            }}
                                        >

                                            <div className="address-details">
                                                <p className="address-title">{address.title}
                                                    {
                                                        address.lat < 1 &&
                                                        <span className='text-start' title='آدرس دستی بدون لوکیشن'>
                                                    <MdWrongLocation className='mx-1 text-danger text-big-2' />
                                                </span>
                                                    }
                                                </p>
                                                <p className="address-text">{address.address}</p>

                                                {
                                                    address.distance_fee > 0 ?
                                                    <div className='text-small-2 mt-3 fw-bold text-danger-emphasis'>
                                                        <PiCoinsBold className='ms-2' />
                                                        هزینه ایاب و ذهاب:
                                                        {" "}
                                                        {currencyFormat.format(address.distance_fee)}

                                                        {" "}
                                                        {config.currency}
                                                    </div> :

                                                        <div  className='text-small-2 mt-3 fw-bold text-danger'>
                                                            خارج از محدوده سرویس دهی
                                                        </div>
                                                }
                                            </div>
                                            {address.id === selectedAddressId ? (
                                                <MdOutlineRadioButtonChecked className="radio-icon selected"/>
                                            ) : (
                                                <MdOutlineRadioButtonUnchecked className="radio-icon"/>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                <button className="add-address-btn" onClick={() => navigate('/add-address')}>
                                    <MdAdd/>
                                    <span>افزودن آدرس جدید</span>
                                </button>
                            </>
                        ) : (
                            <div className="pickup-info-card">
                                <h4>لطفاً برای دریافت خدمات به آدرس زیر مراجعه فرمایید:</h4>
                                <p className="pickup-address">{config.address}</p>
                                <div className="info-notice">
                                    <span>حتماً کد رهگیری درخواست خود را به همراه داشته باشید.</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* --- Date Selection Section --- */}
                <div className="options-section">
                    <h2 className="section-title">
                        <MdCalendarMonth/>
                        <span>انتخاب زمان مراجعه</span>
                    </h2>

                    {
                        config.service_app_settings.urgent_date === "1" &&

                        <div className="date-selection-type">
                            <div className="form-check">
                                <input
                                    className="form-check-input-2"
                                    type="radio"
                                    name="requestTimeType"
                                    id="urgentRadio"
                                    checked={isUrgent}
                                    onChange={() => setIsUrgent(true)}
                                />
                                <label className="form-check-label" htmlFor="urgentRadio">
                                    فوری (در اولین فرصت)
                                </label>
                            </div>
                            {
                                isUrgent && config.service_app_settings.urgent_percent > 0 &&
                                <div className='mt-2 mb-0 alert alert-warning text-small-2 text-justify'>
                                    {config.service_app_settings.urgent_percent}
                                    {" "}
                                    درصد به مبلغ درخواست اضافه خواهد شد!
                                </div>
                            }
                            {
                                isUrgent && config.service_app_settings.urgent_text.length > 0 &&
                                <div className='mt-0 alert alert-info text-small-2 text-justify'>
                                    {config.service_app_settings.urgent_text}
                                </div>
                            }
                            <div className="form-check">
                                <input
                                    className="form-check-input-2"
                                    type="radio"
                                    name="requestTimeType"
                                    id="selectDateRadio"
                                    checked={!isUrgent}
                                    onChange={() => setIsUrgent(false)}
                                />
                                <label className="form-check-label" htmlFor="selectDateRadio">
                                    انتخاب تاریخ مشخص
                                </label>
                            </div>

                        </div>
                    }
                    {/* تقویم فقط در صورت انتخاب "تاریخ مشخص" نمایش داده می‌شود */}
                    {!isUrgent && (
                        <div className="row">
                            <div className="col-6">
                                <div className="datepicker-wrapper">
                                    <DatePicker
                                        value={date}
                                        onChange={setDate}
                                        minDate={new DateObject({calendar: persian}).add(config.service_app_settings.min_date, "days")}
                                        maxDate={new DateObject({calendar: persian}).add(config.service_app_settings.max_date, "days")}
                                        calendar={persian}
                                        locale={persian_fa}
                                        calendarPosition="bottom-right"
                                        className="rmdp-mobile"
                                        inputClass="custom-datepicker-input"
                                        placeholder="تاریخ را انتخاب کنید"
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="time-slot-selector">
                                    <select
                                        className="custom-select"
                                        value={selectedHour}
                                        onChange={(e) => setSelectedHour(e.target.value)}
                                    >
                                        <option value="" disabled>انتخاب ساعت</option>
                                        {config.service_app_settings.request_hours.map((hour, index) => (
                                            <option key={index} value={hour.option}>
                                                {hour.option}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                    )}
                </div>

                {/* --- File Attachment Section --- */}
                {config.service_app_settings.upload_file === "1" &&
                    <div className="options-section">
                        <h2 className="section-title">
                            <MdAttachFile/>
                            <span>افزودن عکس</span>
                        </h2>


                        {/* این input مخفی است و برای باز کردن پنجره انتخاب فایل استفاده می‌شود */}
                        <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            style={{display: 'none'}}
                            accept="image/*,application/pdf" // نوع فایل‌های مجاز را مشخص کنید
                        />

                        {/* اگر فایلی انتخاب نشده بود، دکمه را نشان بده */}
                        {!attachment ? (
                            <button
                                className="file-upload-btn"
                                onClick={() => fileInputRef.current.click()}
                            >
                                <MdAttachFile/>
                                <span>جهت ارسال عکس با گوشی موبایل کلیک کنید</span>
                            </button>
                        ) : (
                            /* اگر فایلی انتخاب شده بود، اطلاعات آن را نشان بده */
                            <div className="selected-file-info">
                                <span>{attachment.name}</span>
                                <button
                                    className="remove-file-btn"
                                    onClick={() => setAttachment(null)}
                                >
                                    <MdClose/>
                                </button>
                            </div>
                        )}
                    </div>
                }

                {/* --- Description Section --- */}
                <div className="options-section">
                    <h2 className="section-title">
                        <MdOutlineDescription/>
                        <span>توضیحات (اختیاری)</span>
                    </h2>
                    <textarea
                        className="description-textarea"
                        rows="4"
                        placeholder="در صورت نیاز به ثبت توضیحات اضافه، اینجا بنویسید..."
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />
                </div>
            </div>


            {/* --- Sticky Footer for Submit Button --- */}
            <div className="action-footer mobile-size-option">
                <button
                    className="submit-btn"
                    onClick={onStoreRequest}
                    disabled={loading || selectedAddressId === 0}
                >
                    <TbArrowBadgeLeft/>
                    <span>
                        ادامه
                    </span>
                </button>
            </div>
        </div>
    );
}

export default SetRequestOptions;
